import { DYNAMIC_ICONIC_SPRITE_URL } from '@dynamic-labs-sdk/client/core';
import { ProviderKernelVersionEnum } from '@dynamic-labs/sdk-api-core';
import { constants } from '@zerodev/sdk';
import type { KERNEL_VERSION_TYPE } from '@zerodev/sdk/types';
import type { EntryPointVersion } from 'viem/account-abstraction';

export const ZERODEV_METADATA = {
  displayName: 'ZeroDev',
  icon: `${DYNAMIC_ICONIC_SPRITE_URL}#smartwallet`,
  normalizedWalletName: 'zerodev',
};

export const ZERODEV_RPC_BASE_URL = 'https://rpc.zerodev.app/api/v2';

export const KERNEL_VERSION_MAP = {
  [ProviderKernelVersionEnum.V33]: constants.KERNEL_V3_3,
  [ProviderKernelVersionEnum.V32]: constants.KERNEL_V3_2,
  [ProviderKernelVersionEnum.V31]: constants.KERNEL_V3_1,
  [ProviderKernelVersionEnum.V30]: constants.KERNEL_V3_0,
  [ProviderKernelVersionEnum.V24]: constants.KERNEL_V2_4,
} as const;

export const ENTRY_POINT_VERSION_MAP: Record<
  EntryPointVersion,
  KERNEL_VERSION_TYPE
> = {
  0.6: constants.KERNEL_V2_4,
  0.7: constants.KERNEL_V3_1,
  0.8: constants.KERNEL_V3_3,
} as const;

export const ERC20_TRANSFER_ABI = [
  {
    inputs: [
      { name: 'to', type: 'address' },
      { name: 'amount', type: 'uint256' },
    ],
    name: 'transfer',
    outputs: [{ name: '', type: 'bool' }],
    stateMutability: 'nonpayable',
    type: 'function',
  },
] as const;
